<template>
    <type-wrapper class="cancel" regular>
        <type-grid row="13" margin>
            <type-image mode="widthFix" :src="image"></type-image>
        </type-grid>
        <type-grid row="23" margin>
            <type-grid row="11" margin style="margin-top: 0;margin-bottom: 0;">
                <type-text type="title" size="9">Order Cancelled</type-text>
            </type-grid>
            <type-grid row="11" margin>
                <type-text type="content" size="6" align="center">Jumping to home page in {{ count }} seconds</type-text>
            </type-grid>
        </type-grid>
    </type-wrapper>
</template>

<script>
export default {
    name: 'cancel',
    data() {
        return {
            count: 2,
            timer: null,
            image: require('../../assets/image/about-img.jpg'), // 默认图片
            pageData: null // 存储页面数据
        }
    },
    async created() {
        // 页面加载时获取页面数据
        await this.getPageData();
        
        // 启动倒计时
        this.startCountdown();
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    },
    methods: {
        // 获取页面数据（图片、标题等）
        async getPageData() {
            try {
                // Get HOSTNAME from config
                const hostname = this.$config.HOSTNAME;
                
                // Initialize hostname_send
                let hostname_send = hostname;
                
                // Check if hostname starts with "pager"
                if (hostname && hostname.startsWith('pager')) {
                    hostname_send = '';
                } else {
                    hostname_send = hostname;
                }

                console.log('HOSTNAME:', hostname);
                
                if (hostname) {
                    const page_tag = 'index'; // 使用当前路由或默认值
                    const result = await this.$http.phamula.host_detail(hostname_send, page_tag);
                    
                    if (result.status === 'success' && result.data) {
                        this.pageData = result.data;
                        
                        // 更新页面标题
                        if (this.pageData.name) {
                            document.title = this.pageData.name + ' - Order Cancelled';
                        }
                        
                        // 更新页面图片
                        if (this.pageData.obj_photo) {
                            this.image = this.pageData.obj_photo;
                        }
                        
                        // 更新 favicon
                        this.updateFavicon(this.pageData.obj_photo);
                    }
                }
            } catch (error) {
                console.error('获取页面数据失败:', error);
            }
        },

        // Favicon 更新方法（改进版）
        updateFavicon(imageUrl) {
            if (!imageUrl) return;
            
            // 方法1: 直接使用图片URL（现代浏览器支持）
            this.setFaviconDirect(imageUrl);
            
            // 方法2: 转换为ICO格式（备用方案）
            this.convertToIco(imageUrl);
        },

        // 直接设置 favicon
        setFaviconDirect(imageUrl) {
            try {
                // 移除现有的 favicon
                const existingLinks = document.querySelectorAll("link[rel*='icon']");
                existingLinks.forEach(link => {
                    if (link.parentNode) {
                        link.parentNode.removeChild(link);
                    }
                });

                // 添加新的 favicon
                const link = document.createElement('link');
                link.rel = 'icon';
                link.type = 'image/png'; // 或根据文件类型动态设置
                link.href = imageUrl + '?t=' + Date.now(); // 添加时间戳避免缓存
                document.head.appendChild(link);

                // 同时添加 shortcut icon（兼容性）
                const shortcutLink = document.createElement('link');
                shortcutLink.rel = 'shortcut icon';
                shortcutLink.href = imageUrl + '?t=' + Date.now();
                document.head.appendChild(shortcutLink);

            } catch (error) {
                console.error('设置 favicon 失败:', error);
            }
        },

        // 将图片转换为 ICO 格式（浏览器端）
        convertToIco(imageUrl) {
            const img = new Image();
            img.crossOrigin = 'anonymous'; // 处理跨域问题
            
            img.onload = () => {
                try {
                    // 创建 canvas
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    
                    // 设置 favicon 标准尺寸
                    canvas.width = 32;
                    canvas.height = 32;
                    
                    // 绘制图片到 canvas
                    ctx.drawImage(img, 0, 0, 32, 32);
                    
                    // 转换为 data URL
                    const dataURL = canvas.toDataURL('image/png');
                    
                    // 设置为 favicon
                    const link = document.createElement('link');
                    link.rel = 'icon';
                    link.type = 'image/png';
                    link.href = dataURL;
                    document.head.appendChild(link);
                    
                } catch (error) {
                    // console.error('转换图片为 favicon 失败:', error);
                    // 降级到直接使用原图片
                    this.setFaviconDirect(imageUrl);
                }
            };
            
            img.onerror = () => {
                // console.error('加载图片失败:', imageUrl);
            };
            
            img.src = imageUrl;
        },

        // 检查主机名对应的 ICO 文件（备用方案）
        checkHostnameIco() {
            const hostname = this.$config.HOSTNAME;
            if (hostname) {
                const icoUrl = `/${hostname}.ico`;
                
                // 检查文件是否存在
                const img = new Image();
                img.onload = () => {
                    this.setFaviconDirect(icoUrl);
                };
                img.onerror = () => {
                    console.log('主机名对应的 ICO 文件不存在:', icoUrl);
                };
                img.src = icoUrl;
            }
        },

        // 启动倒计时
        startCountdown() {
            this.timer = setInterval(() => {
                this.count -= 1;
                if (this.count === 0) {
                    clearInterval(this.timer);
                    this.$router.push({
                        path: '/'
                    });
                }
            }, 1000);
        }
    }
}
</script>

<style scoped lang="less">
    .cancel{
        display: flex;
        flex-wrap: wrap;
    }
</style>